"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildBusinessEventData = void 0;
function buildBusinessEventData(name, customData) {
    let eventData = {};
    eventData[name] = Object.assign({}, customData);
    return eventData;
}
exports.buildBusinessEventData = buildBusinessEventData;
//# sourceMappingURL=build-business-event-data.js.map